import { Box } from '@mui/material';

export const ResizeHandle = ({ onMouseDown }: { onMouseDown: any }) => (
  <Box
    onMouseDown={onMouseDown}
    sx={{
      width: 2,
      cursor: 'col-resize',
      backgroundColor: 'divider',
      '&:hover': { backgroundColor: 'primary.main' },
    }}
  />
);
